export const DEFAULT_WIDTH_IN_PIXELS = '200px';
export const PADDING_IN_PIXELS = '20px';
export const INVALID_FIELD_PERMISSION_MESSAGE =
  "You don't have permission for this field";
